import _toConsumableArray from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ApolloLink, Observable } from "@apollo/client/core";
import { isInputType, isLeafType } from "graphql";
import { GraphQLError } from "graphql/error/GraphQLError";
import pickBy from "lodash.pickby";
import defaultNullFunctions from "./default-null-functions";
import { mapIfArray } from "./map-if-array";
import { isListTypeNode, isNonNullTypeNode, isOperationDefinitionNode } from "./node-types";
import { Serializer } from "./serializer";
import { treatResult } from "./treat-result";
export var ScalarApolloLink = /*#__PURE__*/function (_ApolloLink) {
  _inherits(ScalarApolloLink, _ApolloLink);

  var _super = _createSuper(ScalarApolloLink);

  function ScalarApolloLink(pars) {
    var _this;

    _classCallCheck(this, ScalarApolloLink);

    _this = _super.call(this);
    _this.schema = pars.schema;
    _this.typesMap = pars.typesMap || {};
    _this.validateEnums = pars.validateEnums || false;
    _this.removeTypenameFromInputs = pars.removeTypenameFromInputs || false;
    _this.nullFunctions = pars.nullFunctions || defaultNullFunctions;
    var leafTypesMap = pickBy(_this.schema.getTypeMap(), isLeafType);
    _this.functionsMap = Object.assign(Object.assign({}, leafTypesMap), _this.typesMap);
    _this.serializer = new Serializer(_this.schema, _this.functionsMap, _this.removeTypenameFromInputs, _this.nullFunctions);
    return _this;
  } // ApolloLink code based on https://github.com/with-heart/apollo-link-response-resolver


  _createClass(ScalarApolloLink, [{
    key: "request",
    value: function request(givenOperation, forward) {
      var _this2 = this;

      var operation = this.cleanVariables(givenOperation);
      return new Observable(function (observer) {
        var sub;

        try {
          sub = forward(operation).subscribe({
            next: function next(result) {
              try {
                observer.next(_this2.parse(operation, result));
              } catch (treatError) {
                var errors = result.errors ? _toConsumableArray(result.errors) : [];

                if (treatError instanceof GraphQLError) {
                  errors.push(treatError);
                }

                observer.next({
                  errors: errors
                });
              }
            },
            error: observer.error.bind(observer),
            complete: observer.complete.bind(observer)
          });
        } catch (e) {
          observer.error(e);
        }

        return function () {
          if (sub) sub.unsubscribe();
        };
      });
    }
  }, {
    key: "parse",
    value: function parse(operation, result) {
      return treatResult({
        operation: operation,
        result: result,
        functionsMap: this.functionsMap,
        schema: this.schema,
        validateEnums: this.validateEnums,
        nullFunctions: this.nullFunctions
      });
    }
    /**
     * mutate the operation object with the serialized variables
     * @param operation
     */

  }, {
    key: "cleanVariables",
    value: function cleanVariables(operation) {
      var _this3 = this;

      var o = operation.query.definitions.find(isOperationDefinitionNode);
      var varDefs = (o === null || o === void 0 ? void 0 : o.variableDefinitions) || [];
      varDefs.forEach(function (vd) {
        var key = vd.variable.name.value;
        operation.variables[key] = _this3.serialize(operation.variables[key], vd.type);
      });
      return operation;
    }
  }, {
    key: "serialize",
    value: function serialize(value, typeNode) {
      var _this4 = this;

      if (isNonNullTypeNode(typeNode)) {
        return this.serialize(value, typeNode.type);
      }

      if (isListTypeNode(typeNode)) {
        return mapIfArray(value, function (v) {
          return _this4.serialize(v, typeNode.type);
        });
      }

      return this.serializeNamed(value, typeNode);
    }
  }, {
    key: "serializeNamed",
    value: function serializeNamed(value, typeNode) {
      var typeName = typeNode.name.value;
      var schemaType = this.schema.getType(typeName);
      return schemaType && isInputType(schemaType) ? this.serializer.serialize(value, schemaType) : value;
    }
  }]);

  return ScalarApolloLink;
}(ApolloLink);
export var withScalars = function withScalars(pars) {
  return new ScalarApolloLink(pars);
};